import type { DeepPartial } from '@luna/utils-ts';

import type { Search } from '../../types/Search';

export const searchHUFeatureConfig: DeepPartial<Search> = {
    displayIssuerForShares: true,
};
